<template>
  <Tile
    :background="`${$getCourseBackground(
      course.id || course.objectID,
      getBackgroundSize(height)
    )}`"
    :item="course"
    :isFreeTrialUser="isFreeTrialUser"
    :isResumeSnipeShown="isResumeSnipeShown"
    :isDifficultyShown="isDifficultyShown"
    :isInstructorPictureShown="isInstructorPictureShown"
    :progress="progress"
    :link="$buildContentLink('course', course)"
    :height="height"
    :showAddedDate="showAddedDate"
    :learningAreaColor="getLearningAreaColor(course)"
    :learningArea="getLearningArea(course)"
    @element-rend="handleRememberPosition"
  ></Tile>
</template>

<script>
import { defineComponent } from 'vue'
import Tile from '@/components/layout/Tile.vue'
import {
  getLearningAreaColor,
  getLearningArea,
  getBackgroundSizeBasedOnHeight,
} from '@/helpers'

export default defineComponent({
  name: 'CourseTile',
  components: {
    Tile,
  },
  props: {
    course: {
      type: Object,
      required: true,
    },
    isFreeTrialUser: {
      type: Boolean,
      required: true,
    },
    height: {
      type: [String, Number],
      required: false,
      default: () => 245,
    },
    isResumeSnipeShown: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    isDifficultyShown: {
      type: Boolean,
      required: false,
    },
    isInstructorPictureShown: {
      type: Boolean,
      required: false,
    },
    progress: {
      type: Number,
      required: false,
      default: () => 0,
    },
    showAddedDate: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  data: () => {
    return {
      getLearningAreaColor,
      getLearningArea,
    }
  },
  methods: {
    handleRememberPosition(elId) {
      this.$emit('element-render', elId)
    },
    getBackgroundSize(height) {
      return getBackgroundSizeBasedOnHeight(height)
    },
  },
})
</script>
